import type { CSSProperties, ReactNode } from 'react';

type IconName =
  | 'search' | 'bell' | 'chevron-down' | 'chevron-right' | 'lock' | 'arrow-up-right'
  | 'sliders' | 'doc' | 'alert' | 'check' | 'plus' | 'grid' | 'layers' | 'file'
  | 'wallet' | 'users' | 'shield' | 'folder' | 'spark' | 'building' | 'external'
  | 'x' | 'arrow-right' | 'clock' | 'compass' | 'route' | 'gauge' | 'command'
  | 'send' | 'copy' | 'download' | 'mail' | 'whatsapp' | 'share'
  | 'bold' | 'italic' | 'underline' | 'heading' | 'list' | 'list-ordered'
  | 'quote' | 'minus' | 'rotate-ccw' | 'rotate-cw'
  | 'palette' | 'highlighter' | 'table' | 'column-plus' | 'row-plus' | 'trash';

const P: Record<IconName, ReactNode> = {
  search: <><circle cx="11" cy="11" r="7" /><path d="m20 20-3.2-3.2" /></>,
  bell: <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9M13.7 21a2 2 0 0 1-3.4 0" />,
  'chevron-down': <path d="m6 9 6 6 6-6" />,
  'chevron-right': <path d="m9 6 6 6-6 6" />,
  lock: <><rect x="5" y="11" width="14" height="10" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></>,
  'arrow-up-right': <path d="M7 17 17 7M8 7h9v9" />,
  sliders: <><path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" /></>,
  doc: <><path d="M14 3v5h5" /><path d="M6 21V5a2 2 0 0 1 2-2h6l5 5v13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2Z" /></>,
  alert: <><path d="M10.3 4.3 2.5 18a2 2 0 0 0 1.7 3h15.6a2 2 0 0 0 1.7-3L13.7 4.3a2 2 0 0 0-3.4 0Z" /><path d="M12 9v4M12 17h.01" /></>,
  check: <path d="m5 12 5 5L20 7" />,
  plus: <path d="M12 5v14M5 12h14" />,
  grid: <><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></>,
  layers: <path d="m12 2 9 5-9 5-9-5 9-5ZM3 12l9 5 9-5M3 17l9 5 9-5" />,
  file: <><path d="M14 3v5h5" /><path d="M6 21V5a2 2 0 0 1 2-2h6l5 5v13a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2Z" /><path d="M9 13h6M9 17h4" /></>,
  wallet: <><path d="M3 7a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" /><path d="M16 12h.01M3 9h18" /></>,
  users: <><circle cx="9" cy="8" r="3.5" /><path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6M17 5.5a3.5 3.5 0 0 1 0 6.4M21 20c0-2.5-1.5-4.7-3.6-5.6" /></>,
  shield: <path d="M12 3 5 6v5c0 4.5 3 8 7 10 4-2 7-5.5 7-10V6l-7-3Z" />,
  folder: <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2Z" />,
  spark: <path d="M12 3v4M12 17v4M3 12h4M17 12h4M6.3 6.3l2.4 2.4M15.3 15.3l2.4 2.4M17.7 6.3l-2.4 2.4M8.7 15.3l-2.4 2.4" />,
  building: <><rect x="5" y="3" width="14" height="18" rx="1.5" /><path d="M9 7h.01M15 7h.01M9 11h.01M15 11h.01M9 15h.01M15 15h.01M9 21v-3h6v3" /></>,
  external: <path d="M14 4h6v6M20 4l-9 9M18 14v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5" />,
  x: <path d="M6 6l12 12M18 6 6 18" />,
  'arrow-right': <path d="M4 12h16M14 6l6 6-6 6" />,
  send: <path d="M22 2 11 13M22 2l-7 20-4-9-9-4 20-7Z" />,
  copy: <><rect x="9" y="9" width="12" height="12" rx="2" /><path d="M5 15V5a2 2 0 0 1 2-2h10" /></>,
  download: <path d="M12 3v12M7 10l5 5 5-5M5 21h14" />,
  clock: <><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></>,
  compass: <><circle cx="12" cy="12" r="9" /><path d="m15.5 8.5-2 5-5 2 2-5 5-2Z" /></>,
  route: <><circle cx="6" cy="19" r="2.5" /><circle cx="18" cy="5" r="2.5" /><path d="M8.5 19H15a3.5 3.5 0 0 0 0-7H9a3.5 3.5 0 0 1 0-7h6.5" /></>,
  bold: <path d="M6 4h7a4 4 0 0 1 0 8H6zM6 12h8a4 4 0 0 1 0 8H6z" />,
  italic: <path d="M19 4h-9M14 20H5M15 4 9 20" />,
  underline: <><path d="M6 4v7a6 6 0 0 0 12 0V4" /><path d="M4 21h16" /></>,
  heading: <path d="M6 4v16M18 4v16M6 12h12" />,
  list: <><path d="M8 6h13M8 12h13M8 18h13" /><circle cx="3.5" cy="6" r="1.2" fill="currentColor" stroke="none" /><circle cx="3.5" cy="12" r="1.2" fill="currentColor" stroke="none" /><circle cx="3.5" cy="18" r="1.2" fill="currentColor" stroke="none" /></>,
  'list-ordered': <><path d="M10 6h11M10 12h11M10 18h11" /><path d="M4 4v4M3 8h2M3 15h2a1 1 0 0 1 0 2H3l2 2H3" /></>,
  quote: <path d="M7 8H4v5h3V8l-2 4M17 8h-3v5h3V8l-2 4" />,
  minus: <path d="M5 12h14" />,
  'rotate-ccw': <><path d="M3 4v6h6" /><path d="M3.5 10a9 9 0 1 0 2.1-4.6L3 10" /></>,
  'rotate-cw': <><path d="M21 4v6h-6" /><path d="M20.5 10a9 9 0 1 1-2.1-4.6L21 10" /></>,
  palette: <><circle cx="13.5" cy="6.5" r="1.2" fill="currentColor" stroke="none" /><circle cx="17" cy="10" r="1.2" fill="currentColor" stroke="none" /><circle cx="7" cy="9" r="1.2" fill="currentColor" stroke="none" /><circle cx="9" cy="15" r="1.2" fill="currentColor" stroke="none" /><path d="M12 2a10 10 0 1 0 0 20c1.1 0 2-.9 2-2 0-.6-.2-1-.6-1.4-.3-.4-.5-.8-.5-1.3 0-1.1.9-2 2-2h1.6a4.9 4.9 0 0 0 5-5c0-4.9-4.5-8-9.5-8Z" /></>,
  highlighter: <><path d="M9 11l-4 4v4h4l4-4" /><path d="M13 7l4 4 4-4-4-4-4 4Z" /><path d="M11 9l4 4" /></>,
  table: <><rect x="3" y="4" width="18" height="16" rx="1.5" /><path d="M3 10h18M3 15h18M9 4v16M15 4v16" /></>,
  'column-plus': <><rect x="3" y="4" width="7" height="16" rx="1" /><path d="M16 8v8M20 12h-8" /></>,
  'row-plus': <><rect x="4" y="3" width="16" height="7" rx="1" /><path d="M8 16h8M12 12v8" /></>,
  trash: <><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13" /></>,
  gauge: <><path d="M12 14a9 9 0 1 0-9-9" opacity="0" /><path d="M3.5 15a9 9 0 1 1 17 0" /><path d="m12 13 4-4" /><circle cx="12" cy="13" r="1.4" fill="currentColor" stroke="none" /></>,
  command: <path d="M9 6a3 3 0 1 0-3 3h12a3 3 0 1 0-3-3v12a3 3 0 1 0 3-3H6a3 3 0 1 0 3 3V6Z" />,
  mail: <><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3.5 7 8.5 6 8.5-6" /></>,
  whatsapp: <><path d="M12 3a9 9 0 0 0-7.7 13.7L3 21l4.4-1.3A9 9 0 1 0 12 3Z" /><path d="M8.8 8.5c-.3 0-.6.1-.8.4-.3.3-.9.9-.9 2.1s.9 2.4 1 2.6c.1.2 1.7 2.8 4.3 3.8 2.1.8 2.6.7 3 .6.5-.1 1.4-.6 1.6-1.1.2-.6.2-1 .1-1.1l-1.6-.8c-.2-.1-.5-.2-.7.1l-.6.8c-.1.2-.3.2-.5.1-.7-.3-1.4-.6-2.2-1.6-.2-.3 0-.4.1-.6l.4-.5c.1-.2 0-.4 0-.5l-.7-1.7c-.2-.4-.4-.4-.6-.4Z" fill="currentColor" stroke="none" /></>,
  share: <><circle cx="6" cy="12" r="2.4" /><circle cx="17" cy="6" r="2.4" /><circle cx="17" cy="18" r="2.4" /><path d="m8.2 10.9 6.6-3.7M8.2 13.1l6.6 3.7" /></>,
};

export function Icon({
  name,
  size = 18,
  className,
  strokeWidth = 1.6,
  style,
}: {
  name: IconName;
  size?: number;
  className?: string;
  strokeWidth?: number;
  style?: CSSProperties;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      style={style}
      aria-hidden="true"
    >
      {P[name]}
    </svg>
  );
}

export type { IconName };
